export { default as PlusFAQBlock } from './PlusFAQBlock';
